<template>
  <div style="text-align: center;">
    <form @submit.prevent="login">
      <h2>Login</h2>
      <input v-model="username" placeholder="Username" required />
      <input v-model="password" type="password" placeholder="Password" required />
      <button type="submit" :disabled="loading">Login</button>
      <div v-if="error" style="color:red" class="error">{{ error }}</div>
    </form>
  </div>
</template>

<script>
import { safeFetch } from '@/utils/fetch'; // Adjust the path as necessary
// Login page: Authenticates user and stores JWT token in localStorage
export default {
  name: 'Login',
  data() {
    return {
      username: '',   // Username input
      password: '',   // Password input
      loading: false, // Loading state
      error: null,    // Error message
    };
  },
  methods: {
    // Login method: POSTs credentials to backend and stores token
    async login() {
      this.loading = true;
      this.error = null;
      try {
        console.log("Attempting to fetch token"); // Debugging line
        const url = `/wp-json/jwt-auth/v1/token`;
        console.log("Fetch URL:", url); // Log the constructed URL
        const response = await safeFetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username: this.username, password: this.password }),
        });
        if (!response.ok) throw new Error('Invalid credentials');
        const data = await response.json();
        localStorage.setItem('authToken', data.token); // Store token
        setTimeout(() => window.location.reload(), 100); // Redirect after login
        window.location.reload();
      } catch (err) {
        this.error = err.message;
        console.error("Login error:", err); // Debugging line
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}

form {
  background: #efefef;
  padding: 2rem 2.5rem;
  border-radius: 8px;
  border-style: solid;
  border-width: 1px;
  border-color: #d9d9d9;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 300px;
}

input {
  padding: 0.7rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
}

button {
  padding: 0.7rem;
  background: #1976d2;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s;
}

button:disabled {
  background: #90caf9;
  cursor: not-allowed;
}

h2 {
  margin-bottom: 1.5rem;
}

.error {
  margin-top: 0.5rem;
  font-size: 0.95rem;
  min-height: 1.2em;           /* Reserve space for error */
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
</style>